import { Component, EventEmitter, forwardRef, Inject, Input, OnInit, Output } from '@angular/core';
import { RadioGroupComponent } from '../radio-group.component';

@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.less']
})
export class RadioComponent implements OnInit {
  @Input() isDisabled: boolean;
  @Input() label: string;
  @Input() theme: string;
  @Input() customClass: string;
  @Input() value: string;
   checked: boolean = false;


  constructor(@Inject(forwardRef(() => RadioGroupComponent)) public radioGroup: RadioGroupComponent) { }

  ngOnInit(): void {
    this.checked = this.radioGroup.value === this.value;
  }
  change() {
    if (this.isDisabled || this.checked)
      return;

    this.radioGroup.updateValue(this.value);
  }
}
